namespace GeniuzPOS.Purchase {
    export class PoCNRTVAppDtColumns {
        static columnsKey = 'Purchase.PoCNRTVAppDt';
    }
}
